export default [{
	code: "alliance",
	name: "Alliance"
}, {
	code: "horde",
	name: "Horde"
}];